<template>
  <div class="animated fadeIn">
    <div v-if="flowPaperContent">
      <div @click="handleClose()" class="x-wrapper x-absolute">
          <icon name="close" scale="1.5" class="close-icon pointer"></icon>
      </div>
      <div class="responsive-iframe" :key="myBook.id" v-for="myBook in books">
          <iframe :src="$store.state.urlLink+ myBook.bookId +'/'" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>

    <div v-if="!flowPaperContent">
      <App-SideMenu></App-SideMenu>

        <main class="cd-main-content landing-color">
          <div class="bk-content">
            <div class="book-pic-bg" :key="myBook.id" v-for="myBook in books">
              <a id="book-pic-wrapper">
                <img :src="$store.state.urlLink+myBook.bookId+'.png'" class="pic-element" />
              </a>
            </div>
          </div>

          <div class="book-pic-desc">
            <div class="book-pic-details">
              <h5 id="book-title-font">
                  <strong :key="myBook.id" v-for="myBook in books">
                    {{myBook.bookName}}
                  </strong>
              </h5>
            </div>
          </div>

          <div class="bk-pic-nav">
            <ul class="bk-pic-nav-info" :key="myBook.id" v-for="myBook in books">
              <li class="bk-pic-nav-item">{{myBook.datePublished}}</li>
              <li class="bk-pic-nav-item">Language : {{myBook.language}}</li>
            </ul>
          </div>

          <div class="bk-btn-desc">
            <div v-show="!statusLogin" class="bk-button-nav">
              <!--<button @click="handleFlowPaper()" v-ripple="'rgba(255, 255, 255, 0.2)'" id="bk-btn-preview">PREVIEW</button>
              <button v-ripple="'rgba(255, 255, 255, 0.2)'" id="bk-btn-pay">BUY FOR RM 9.99</button>
              <button v-ripple="'rgba(255, 255, 255, 0.2)'" id="bk-btn-subscribe">SUBSCRIBE NOW FOR RM 29.99</button>
              <button v-ripple="'rgba(0, 90, 169, 0.2)'" id="bk-btn-all-content">ACCESS ALL CONTENT FOR RM 49.99</button>-->
              
              <button @click="handleLogin()" v-ripple="'rgba(255, 255, 255, 0.2)'" id="bk-btn-subscribe">LOGIN TO READ</button>
              <h3></h3>
              
            </div>
            <div v-show="statusLogin" class="bk-button-nav">
              <button @click="handleFlowPaper()" v-ripple="'rgba(255, 255, 255, 0.2)'" id="bk-btn-all-content">READ</button>
            </div>
          </div>

          <div v-show=description id="bk-book-text-wrapper">
            <div class="bk-pic-text-detail">
              <div class="truncate truncate1" v-bind:class="{toggleReadMore: readMoreActive}" style="color: #fff">
                <p :key="myBook.id" v-for="myBook in books"> 
                  {{myBook.description}}
                </p>
              </div>
            </div>


            <div class="white-divider">
              <span class="divider-ball" v-on:click="readMoreActive = !readMoreActive" v-bind:class="{flipBall: readMoreActive}">
                <span class="divider-icon">

                </span>
              </span>
            </div>

            <!--magazine with same issue
            <div v-if='books[0].bookType == "Magazine"' class="bk-pic-text-detail">
              {{SameIssueProvide()}}
              <h4>
                Another Issue From {{books[0].bookName}}
              </h4>
            </div>-->

          </div>
          </main>
      <!-- landing-main-content -->
      </div>

    </div>
</template>

<script scoped>
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import db from '../components/firebase/firebaseinit'


export default 
{
  data() 
  {
    return {
      servicesContent: true,
      categoriesContent: true,
      readMoreActive: false,
      flowPaperContent: false,
      description: true,
      statusLogin:false,
      books :[],
      sameIssue:[],
      NewLog: true,
      currentOpened : 0,

    }
  },
  computed: 
  {
    nameState()
    {
        return this.$store.state.idState
    },
  },
  methods: 
  {
      handleHome()
      {
        this.$router.push({
            name: "landing"
        });
      },

      handleLogin()
      {
        this.$router.push({
            name: "login"
        });
      },

      handleClose()
      {
        this.bodyContent = true;
        this.flowPaperContent = false;
      },
      handleFlowPaper()
      {
        this.CheckLog()
        setTimeout(function()
        {
          this.bodyContent = false;
          this.flowPaperContent = true;
        }.bind(this), 1000);
        setTimeout(function()
        {
            window.onbeforeunload = function () {
            console.log('add z-index')
            var wrapper =document.getElementsByClassName('x-wrapper')
            wrapper[0].style.zIndex = "10000";
            }
        },5*1000);
      },

      CheckLog()
      {
        //console.log("Done check")
        db.collection('history_log').get().then(query => 
        {
          query.forEach(doc => 
          {
              //.where('bookId','==', books[0].bookId)
              if(doc.data().bookId == this.books[0].bookId && doc.data().email == localStorage.getItem('session'))
              {
                this.currentOpened = doc.data().count
                //console.log(this.currentOpened)
                this.UpdateLog()
                this.NewLog = false;
              }
          })

          if(this.NewLog)
          {
            this.CreateLog()
          }
        })
      },

      CreateLog()
      {
        //console.log("Create")
        db.collection('history_log').add(
        { 
          logId : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
          bookId: this.books[0].bookId,
          bookName :this.books[0].bookName,
          email : localStorage.getItem('session'),
          count : 1
          
        })
      },

      UpdateLog()
      {
        //console.log("Update")
        db.collection('history_log').where('email','==', localStorage.getItem('session')).get().then(query => 
        {
          query.forEach(doc =>
          {
            if(this.books[0].bookId == doc.data().bookId)
            {
              doc.ref.update(
              {
                count : ++this.currentOpened,
              })
            }
            
          })
        })
      },


      preventMobileScroll(event)
      {
        if(this.hideScroll){
            event.preventDefault();
            event.stopPropagation();
        } else 
        {
            event.unbind();
        }
      },
      checkLogin()
      {
          if(localStorage.getItem('session')===null)
          {
              this.statusLogin=false
          }
          else
          {
              this.statusLogin=true
          }
      },
  },

  created()
  {
      this.checkLogin()
      //console.log("From local Storage : " + localStorage.getItem('book'))

      db.collection('books').where('bookId','==', localStorage.getItem('book')).get().then(query => 
      {
          query.forEach(doc => 
          {
              const data = 
              {
                  id: doc.id,
                  bookId: doc.data().bookId,
                  bookName: doc.data().bookName,
                  bookType: doc.data().bookType,
                  datePublished: doc.data().datePublished,
                  genre: doc.data().genre,
                  language: doc.data().language,
                  description : doc.data().description
              }
              this.books.push(data)
          })
      })

      

  }

};
</script>

<style lang="scss" scoped>
.x-wrapper.x-absolute{
    position: fixed;
    width: 30px;
    height: 30px;
    line-height: 40px;
    background-color: #005aa9;
    border-radius: 40px;
    box-sizing: content-box;
    cursor: pointer;
    z-index: 10;
}

.responsive-iframe {
    position: relative;
    padding-bottom: 56.25%; /*16:9*/
    height: 100vh;
    overflow: hidden;
    iframe {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

  .white-divider{
    height: 1px;
    border-bottom: 1px solid #e3e3e3;
    text-align: center;
    margin: 20px 0;
  }

  .divider-icon{
    width: 16px;
    height: 16px;
    background-size: 100% 30px;
    background-position: center bottom;
        display: inline-block;
            vertical-align: baseline;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21--%20Generator%3A%20Adobe%20Illustrator%2018.1.1%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200%29%20%20--%3E%0D%0A%3Csvg%20width%3D%2212%22%20height%3D%2216%22%20version%3D%221.1%22%20id%3D%22arrow%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20viewBox%3D%226%2011.4%2012%2016%22%20enable-background%3D%22new%206%2011.4%2012%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cpath%20id%3D%22white%22%20fill%3D%22%23FFFFFF%22%20d%3D%22M16.8%2C20.6c-0.3-0.3-0.7-0.3-1%2C0l-3.8%2C4l-3.8-4c-0.3-0.3-0.7-0.3-1%2C0c-0.3%2C0.3-0.3%2C0.7%2C0%2C1%0D%0A%09l4.3%2C4.5c0%2C0%2C0%2C0%2C0%2C0c0%2C0%2C0%2C0%2C0%2C0c0.1%2C0.1%2C0.3%2C0.2%2C0.5%2C0.2c0.2%2C0%2C0.4-0.1%2C0.5-0.2l4.3-4.5C17%2C21.3%2C17%2C20.9%2C16.8%2C20.6z%22/%3E%0D%0A%3Cpath%20id%3D%22grey%22%20fill%3D%22%236D6F71%22%20d%3D%22M16.8%2C12.6c-0.3-0.3-0.7-0.3-1%2C0l-3.8%2C4l-3.8-4c-0.3-0.3-0.7-0.3-1%2C0c-0.3%2C0.3-0.3%2C0.7%2C0%2C1%0D%0A%09l4.3%2C4.5c0%2C0%2C0%2C0%2C0%2C0c0%2C0%2C0%2C0%2C0%2C0c0.1%2C0.1%2C0.3%2C0.2%2C0.5%2C0.2c0.2%2C0%2C0.4-0.1%2C0.5-0.2l4.3-4.5C17%2C13.3%2C17%2C12.9%2C16.8%2C12.6z%22/%3E%0D%0A%3C/svg%3E%0D%0A');
  }

  .divider-ball{
    width: 30px;
    height: 30px;
    display: inline-block;
    line-height: 40px;
    position: relative;
    top: -30px;
    background-color: #005aa9;
    border-radius: 40px;
    border: 15px solid #141414;
    box-sizing: content-box;
    cursor: pointer;
  }

  .flipBall{
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .truncate {
    max-height: 150px; //use max height instead of height so transition works
    overflow: hidden;
    position: relative;
    width: 100%;
    transition: max-height 0.5s;
    &:after {
      transition: opacity 0.5s;
      opacity: 1;
      content: "Filler";
      display: block;
      width: 100%;
      background: #fff;
      background: linear-gradient(
        to bottom,
        rgba(20, 20, 20, 0) 0%,
        rgba(20, 20, 20, 1) 50%,
        rgba(20, 20, 20, 1) 100%
      );
      color: #141414;
      font-weight: bold;
      text-align: right;
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      box-sizing: border-box;
    }
    p{
      text-align: justify;
    }
  }

  .toggleReadMore{
    max-height: 1500px; //needs to be bigger than the content will ever get
      &:after {
        opacity: 0;
      }
  }
  
#video-container {
    display: flex;
    video {
        width: 100%;
        max-width: 1200px;
        // height: 240px;
    }
    .content {
        margin: 0 auto;
    }
}

@media (max-width: 768px) and (orientation: landscape){
  #video-container {
    video {
        height: 80vh;
    }
  }
}

.x-wrapper{
  display: block;
  margin: 10px 10px 50px 10px;
  z-index: 1000;
  right: 0;
}

 .close-icon {
    display: block;
    color: #fff;
    margin-top: 1.5px;
    margin-left: 5.5px;
  }

  .close-icon:hover {
    color: rgb(206, 205, 205);
  }
  
.read-button {
  position: absolute;
  width: 500px;
  text-align: center;
  opacity: 0;
  transition: opacity .35s ease;
}

.read-button a {
  width: 200px;
  padding: 12px 48px;
  text-align: center;
  color: white;
  border: solid 2px white;
  background-color: grey;
  z-index: 1;
}

#book-pic-wrapper{
    display: block;
    margin: 0 auto;
    text-align: center;

  // .pic-element:hover{
  //     filter: blur(2px)
  //     // .read-button{
  //     //   opacity: 1;
  //     // }
  // }
}

#play-btn-wrapper{
  top: 50%;
  left: 49%;
  right: 0%;
  position: absolute;
  display: inline-block;

  #play-btn{
    width: 50px;

    &:hover{
      transition: all 0.5s cubic-bezier(0,0,0.5,1);
        transform: scale(1.1);
    }
  }
}

@media (max-width: 768px) and (orientation: portrait){
  #play-btn-wrapper {
    left: 48%;
    #play-btn{
      width: 40px;
    }
  }
}

@media (max-width: 768px) and (orientation: landscape){
  #play-btn-wrapper {
    left: 48%;
    #play-btn{
      width: 40px;
    }
  }
}

.video-js{
  background-color: transparent !important;
}

.vjs_video_3-dimensions{
  height: 320px !important;
}

@media (max-width: 768px){
  .vjs_video_3-dimensions{
  height: 150px !important;
}
}

// .video-js .vjs-control-bar{
//   width: 570px !important;
//   margin: 0 auto;
// }

#book-title-font {
  font-size: 18px;
}

#bk-tabs {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

.bk-wrapper {
  position: relative;
}


.bk-issues {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);

  text-align: center;
  width: 100%;
  height: 100%;
  list-style-type: none;
  padding: 0;
  //margin: 0.75rem;
}

@media (min-width: 768px) {
  #bk-tabs,
  .bk-issues {
    max-width: 1200px;
  }
}

/*
@media (min-width: 768px){
  .bk-issues{
    margin-right: 0 !important;
  }
}
*/

.bk-issue-item {
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
  white-space: normal;
  list-style-type: none;
  width: 14.666666%;
  padding: 0.4% 0.2%;

  img {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    display: block;
    width: 100%;
    min-height: 180px;
  }
}

@media (max-width: 768px) {
  .bk-issue-item {
    width: 23%;
  }
}

#bk-body {
    height: 100%;
  font-size: 100%;
    overflow-y: visible !important;
}

* {
  box-sizing: border-box;
}

.bk-content {
  position: relative;
  left: 0;
  right: 0;
  margin-top: 20px;
  z-index: 2;
}

@media (max-width: 768px) and (orientation: landscape) {
  // .bk-content {
  //   margin-top: 10vw;
  // }
}

// TOP PICTURE
.pic-element {
  width: 30vmin;
  min-height: 160px;
  min-width: 160px;
  max-width: 250px;
  margin: 20px auto 0 auto;
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.75);
}

// BOOK DESCRIPTION
.book-pic-desc {
  position: relative;
  z-index: 2;
  color: white;
  display: block;
  margin: 20px 0;
  text-align: center;
}

@media (max-width: 992px) {
  .book-pic-desc {
    margin: 20px 5%;
  }
}

/* BOTTTTOM OF ZE PICCTURE */
.bk-pic-nav-info {
  position: relative;
  /*
  background: rgba(111, 111, 111, 0.4);
  border-radius: 3px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  */
  text-align: center;
  z-index: 2;
  margin: 10px 30vw 0;

  .bk-pic-nav-item {
    padding: 15px;
    display: inline-block;
  }
}

.bk-pic-nav-item {
  color: #fff;
  font-weight: 500;
}

.bk-pic-rating {
  color: #6c3;
  font-weight: 600;
}

@media (max-width: 990px) {
  .bk-pic-nav-info {
    margin: 10px 10vmin 0;

    .bk-pic-nav-item {
      padding: 5px;
    }
  }

  .bk-pic-nav-info li {
    font-size: 12px;
  }
}

// BUTTONSSSS
.bk-btn-desc {
  position: relative;
  margin: 10px 30% 0;
  z-index: 2;
}

@media (max-width: 992px) {
  .bk-btn-desc {
    margin: 20px 5%;
  }
}

.bk-button-nav button {
  color: #fff;
  border: none;
  margin: 0.5% auto;
  padding: 10px 1%;
  border-radius: 7px;
}

@media (max-width: 768px) {
  .bk-button-nav button {
    padding: 6px 1%;
  }
}

#bk-btn-preview,
#bk-btn-pay {
  display: inline-block;
  width: 49%;
}

#bk-btn-preview {
  background-color: #222;
  float: left;
}

#bk-btn-pay {
  background-color: #005aa9;
  float: right;
}

#bk-btn-subscribe,
#bk-btn-all-content {
  width: 100%;
}

#bk-btn-subscribe {
  background-color: #005aa9;
}

#bk-btn-all-content {
  font-weight: bolder;
  color: #005aa9;
  background-color: #fff;
}

/* LOOOOOOOOOONG TEXT */
#bk-book-text-wrapper {
  position: relative;
  z-index: 2;
  margin: 20px 30%;
}

@media (max-width: 992px) {
  #bk-book-text-wrapper {
    margin: 20px 5%;
  }
}


  /* MIiiiddle NAVigationn! */
  .nav-pic-features {
    display: block;
    margin: 0 30%;
    background-color: transparent;
    /*box-shadow: 0px 8px 30px -4px hsla(0, 0%, 0%, 0.6);*/
    border-radius: 3px;
  }

  @media (max-width: 990px) {
    .nav-pic-features {
      margin: 0 2%;
    }
  }

  .navBar {
    text-align: center;
    display: inline-block;
    background-color: transparent;
    margin: 0 auto;
    border-radius: 3px;
    .navMenu {
      list-style-type: none;
      margin: 0;
      padding: 0;
      .menuItem {
        display: inline-block;
        margin: 0;
        .itemLink {
          display: block;
          color: #fff;
          text-decoration: none;
          height: 60px;
          width: 100px;
        }
        .first {
          border-radius: 3px 0 0 3px;
        }
        .last {
          border-radius: 0 3px 3px 0;
        }
        .itemLink .itemIcon {
          display: block;
          padding: 4px 0 0 0;
          line-height: 20px;
        }
      }
    }
  }


//TABBS
#bk-tabs {
  z-index: 2;
  position: relative;
  //margin: 0 10%;
  font-weight: 800;
  background: rgba(111, 111, 111, 0.4);
  border-radius: 3px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);

  #empty-tab {
    color: #fff;
  }

  #bk-issue {
    color: blueviolet;
  }
}
</style>



// WEBPACK FOOTER //
// ViewContent.vue?b9d4b502